import React, { createContext, useContext, useState, useEffect } from "react";

export interface GlobalContextProps {
  GatewayToken: string | null;
  UseSpanishVariation: boolean | false;
  InfermedicaToken: string | null;
  DataDogToken: string | null;
  HasError: boolean;
  ErrorMessage: string;
  Locale: string;
  CdoName: string;
  AppID: string;
  Loaded:Boolean;
}

const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);
let globalContextData: GlobalContextProps = {
  GatewayToken: null,
  UseSpanishVariation: false,
  InfermedicaToken: null,
  DataDogToken: null,
  HasError: false,
  ErrorMessage: "",
  Locale: "",
  CdoName: "",
  AppID:"",
  Loaded: false
};

export const GlobalContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [contextData, setContextData] = useState<GlobalContextProps>({
    GatewayToken: null,
    UseSpanishVariation: false,
    InfermedicaToken: null,
    DataDogToken: null,
    HasError: false,
    ErrorMessage: "",
    Locale: "",
    CdoName: "",
    AppID: "",
    Loaded: false
  });

  function getAppContext(): GlobalContextProps {
    let _base64AppDataElement = document.getElementById('_appData') as HTMLInputElement | null;
    if (_base64AppDataElement) {
      let _base64AppData = _base64AppDataElement.value;
      if (_base64AppData) {
        try {
          let appData = JSON.parse(atob(_base64AppData));
          const _appContext: GlobalContextProps = {
            GatewayToken: appData.gtwyToken || null,
            UseSpanishVariation: appData.useSpanishVariation || false,
            InfermedicaToken: appData.infermedicaToken || '',
            DataDogToken: appData.ddToken || null,  
            HasError: appData.hasError || false,
            ErrorMessage: appData.errorMessage || "",
            Locale: appData.locale || '',
            CdoName: appData.cdoName || "",
            AppID: appData.appId || "",
            Loaded: true
          }
          return _appContext;
        } catch (error) {
          console.error('Error parsing app data:', error);
        }
      }
    }
    return {
      GatewayToken: null,
      UseSpanishVariation: false,
      InfermedicaToken: null,
      DataDogToken: null,
      HasError: false,
      ErrorMessage: "",
      Locale: "",
      CdoName: "",
      AppID:"",
      Loaded: false}
  }

  useEffect(() => {
    let _appContext = getAppContext();
    console.log('GlobalContextProvider useEffect called with app context:', _appContext);
    setContextData(_appContext);
    globalContextData = _appContext; 
  }, []);

  return (
    <GlobalContext.Provider value={contextData}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = (): GlobalContextProps => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalContextProvider");
  }
  return context;
};

export const getGlobalContext = (): GlobalContextProps => globalContextData;

export const updateGlobalContextTokens = (payload: {
  GatewayToken?: string | null;
  InfermedicaToken?: string | null;
}) => {
  globalContextData = {
    ...globalContextData,
    GatewayToken: payload.GatewayToken ?? globalContextData.GatewayToken,
    InfermedicaToken: payload.InfermedicaToken ?? globalContextData.InfermedicaToken,
    Loaded: true
  };
};
